/**
 * Sun Direction Legend Configuration
 *
 * Defines the legend configuration for sun direction indicator lines
 */

import type { LegendConfig } from '../AnalysisMap.types'

/**
 * Sun direction legend configuration
 */
export const SUN_DIRECTION_LEGEND_CONFIG: Record<string, LegendConfig> = {
  'sun-direction': {
    title: 'Sun Direction',
    type: 'categorical',
    entries: [
      { color: '#ff8c00', label: 'Sunrise' },
      { color: '#ff4500', label: 'Sunset' },
      { color: '#ffd700', label: 'Current Sun' },
    ],
  },
}

/**
 * Get legend config for sun direction layer
 */
export function getSunDirectionLegendConfig(
  layerId: string
): LegendConfig | undefined {
  return SUN_DIRECTION_LEGEND_CONFIG[layerId]
}

/**
 * Check if a layer has a sun direction legend
 */
export function hasSunDirectionLegend(layerId: string): boolean {
  return layerId in SUN_DIRECTION_LEGEND_CONFIG
}
